"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IaFillingScenarioId = void 0;
/**
 * The id of the scenario for which a filling shall be created.
 */
var IaFillingScenarioId;
(function (IaFillingScenarioId) {
    /** Try everything to achieve the lowest loss by all costs. */
    IaFillingScenarioId["AllIn"] = "AllIn";
    /** Try only standard vertical IAs. */
    IaFillingScenarioId["StandardVerticals"] = "StandardVerticals";
    /** Try to use horizontal shelves. */
    IaFillingScenarioId["HorizontalContinuousShelf"] = "HorizontalContinuousShelf";
    /** Try to use multiple horizontal shelves. */
    IaFillingScenarioId["MultipleHorizontalContinuousShelves"] = "MultipleHorizontalContinuousShelves";
    /** Try only standard vertical IAs but allow stacking of Leitungen. */
    IaFillingScenarioId["StandardVerticalsWithStackedLeitungen"] = "StandardVerticalsWithStackedLeitungen";
    /** Fill the left child of an Espool. */
    IaFillingScenarioId["EspoolLeft"] = "EspoolLeft";
    /** Fill the right child of an Espool. */
    IaFillingScenarioId["EspoolRight"] = "EspoolRight";
    /** Try only standard vertical IAs from left to right. */
    IaFillingScenarioId["EspoolLinearFromLeft"] = "EspoolLinearFromLeft";
    /** Try only standard vertical IAs from right to left. */
    IaFillingScenarioId["EspoolLinearFromRight"] = "EspoolLinearFromRight";
})(IaFillingScenarioId = exports.IaFillingScenarioId || (exports.IaFillingScenarioId = {}));
//# sourceMappingURL=IaFillingScenarioId.js.map